import { initReactI18next } from 'react-i18next';
import i18n from "i18next";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "Back": "Back",
          "None": "None of the above.",
          "Page": "Page",
          "of": "of",
          "Other": "Other",
          "institution-placeholder": "Enter your Institution name",
          "country-placeholder": "Select a country",
          "no-options-message": "No options",
          "start-typing-message": "Start typing...",
          "institution-label": "Institution Name (in English)",
          "country-label": "Country (in English)",
          "job-title": {
            "placeholder": "Select job title",
            "options": {
              "academicStaff": "Academic Staff",
              "administrativeStaff": "Administrative Staff",
              "regulator": "Government Official/Regulator",
              "researcher": "Researcher",
              "other": "Job Seeker/Student/Other"
            }
          },
          "All steps": "All steps",
          "Password": "Password",
          "draft-notion": "All changes are saved by clicking Next",
          "draft-final-notion": "Benchmark will be created after clicking Submit",
          "existing-user-error": "A user with this email already exists. Please enter password to continue",
          "invalid-email-error": "Email is invalid",
          "password-error": "Password is incorrect",
          "credentials-panel": "Access Credentials",
          "result-chart":{
            "owner-label": "Owner",
            "score-label": "Score",
            "user-score-label": "Your results",
            "vitae-score-label": "Vitae 360° Benchmark",
            labels: {
              0: "(0) Non-existent",
              1: "(1) Nascent",
              2: "(2) Emerging",
              3: "(3) Advanced",
              4: "(4) Best-In-Class"
            },
            "updated-at-label": "Last updated on"
          },
        }
      },
      es: {
        translation: {
          "Back": "Back",
          "None": "Ninguna de las anteriores.",
          "Page": "Página",
          "of": "de",
          "Other": "Otro",
          "institution-placeholder": "Ingrese el nombre de su institución",
          "country-placeholder": "Seleccione un país",
          "start-typing-message": "Empieza a escribir...",
          "no-options-message": "Sin opciones",
          "institution-label": "Nombre de la Institución (en inglés)",
          "country-label": "País (en inglés)",
          "job-title": {
            "placeholder": "Selecciona el cargo",
            "options": {
              "academicStaff": "Personal Académico",
              "administrativeStaff": "Personal Administrativo",
              "regulator": "Funcionario Gubernamental/Regulador",
              "researcher": "Investigador",
              "other": "Buscador de Empleo/Estudiante/Otro"
            }
          },
          "All steps": "Todos los pasos",
          "Password": "Contraseña",
          "draft-notion": "Todos los cambios se guardan al hacer clic en Siguiente",
          "draft-final-notion": "El benchmark se creará después de hacer clic en Enviar",
          "existing-user-error": "Ya existe un usuario con esta dirección de correo electrónico. Por favor, introduzca la contraseña para continuar",
          "invalid-email-error": "El correo electrónico no es válido",
          "password-error": "La contraseña es incorrecta",
          "credentials-panel": "Credenciales de acceso",
          "result-chart":{
            "owner-label": "Propietario",
            "score-label": "Puntuación",
            "user-score-label": "Tus resultados",
            "vitae-score-label": "Punto de referencia Vitae 360°",
            labels: {
              0: "(0) Inexistente",
              1: "(1) Naciente",
              2: "(2) Emergentes",
              3: "(3) Avanzada",
              4: "(4) Mejor en su clase"
            },
            "updated-at-label": "Última actualización el"
          },
        }
      },
      ar: {
        translation: {
          "Back": "رجوع",
          "None": "لا شيء مما سبق.",
          "Page": "صفحة",
          "of": "من",
          "Other": "أخرى",
          "institution-placeholder": "أدخل اسم مؤسستك",
          "country-placeholder": "اختر دولة",
          "start-typing-message": "ابدأ الكتابة...",
          "no-options-message": "لا توجد خيارات",
          "institution-label": "اسم المؤسسة (بالإنجليزية)",
          "country-label": "البلد (بالإنجليزية)",
          "job-title": {
            "placeholder": "اختر المسمى الوظيفي",
            "options": {
              "academicStaff": "الكادر الأكاديمي",
              "administrativeStaff": "الكادر الإداري",
              "regulator": "مسؤول حكومي/جهة تنظيمية",
              "researcher": "باحث",
              "other": "باحث عن عمل/طالب/آخر"
            }
          },
          "All steps": "جميع الخطوات",
          "Password": "كلمة المرور",
          "draft-notion": "يتم حفظ جميع التغييرات عند النقر على التالي",
          "draft-final-notion": "سيتم إنشاء المعيار بعد النقر على إرسال",
          "existing-user-error": "يوجد مستخدم بالفعل بهذا البريد الإلكتروني. يرجى إدخال كلمة المرور للمتابعة",
          "invalid-email-error": "البريد الإلكتروني غير صالح",
          "password-error": "كلمة المرور غير صحيحة",
          "credentials-panel": "بيانات اعتماد الوصول",
          "result-chart":{
            "owner-label": "المالك",
            "score-label": "النتيجة",
            "user-score-label": "نتائجك",
            "vitae-score-label": "المعيار Vitae 360°",
            labels: {
              0: "(0) غير موجود",
              1: "(1) ناشئ",
              2: "(2) ناشئ",
              3: "(3) متقدم",
              4: "(4) الأفضل في فئته"
            },
            "updated-at-label": "آخر تحديث في"
          },
        }
      },
      fr: {
        translation: {
          "Back": "Retour",
          "None": "Aucune des réponses ci-dessus.",
          "Page": "Page",
          "of": "sur",
          "Other": "Autre",
          "institution-placeholder": "Entrez le nom de votre établissement",
          "country-placeholder": "Sélectionnez un pays",
          "no-options-message": "Aucune option",
          "start-typing-message": "Commencez à taper...",
          "institution-label": "Nom de l'établissement (en anglais)",
          "country-label": "Pays (en anglais)",
          "job-title": {
            "placeholder": "Sélectionnez le poste",
            "options": {
              "academicStaff": "Personnel Académique",
              "administrativeStaff": "Personnel Administratif",
              "regulator": "Fonctionnaire Gouvernemental/Régulateur",
              "researcher": "Chercheur",
              "other": "Demandeur d’emploi/Étudiant/Autre"
            }
          },
          "All steps": "Toutes les étapes",
          "Password": "Mot de passe",
          "draft-notion": "Toutes les modifications sont enregistrées en cliquant sur Suivant",
          "draft-final-notion": "L’évaluation sera créée après avoir cliqué sur Envoyer",
          "existing-user-error": "Un utilisateur avec cet e-mail existe déjà. Veuillez entrer le mot de passe pour continuer",
          "invalid-email-error": "L’adresse e-mail n’est pas valide",
          "password-error": "Mot de passe incorrect",
          "credentials-panel": "Identifiants d’accès",
          "result-chart":{
            "owner-label": "Propriétaire",
            "score-label": "Score",
            "user-score-label": "Vos résultats",
            "vitae-score-label": "Référence Vitae 360°",
            labels: {
              0: "(0) Inexistant",
              1: "(1) Naissant",
              2: "(2) Émergent",
              3: "(3) Avancé",
              4: "(4) Meilleur de sa catégorie"
            },
            "updated-at-label": "Dernière mise à jour le"
          },
        }
      },
      pt: {
        translation: {
          "Back": "Voltar",
          "None": "Nenhuma das opções acima.",
          "Page": "Página",
          "of": "de",
          "Other": "Outro",
          "institution-placeholder": "Introduza o nome da sua Instituição",
          "country-placeholder": "Selecione um país",
          "no-options-message": "Sem opções",
          "start-typing-message": "Comece a escrever...",
          "institution-label": "Nome da Instituição (em inglês)",
          "country-label": "País (em inglês)",
          "job-title": {
            "placeholder": "Selecione o cargo",
            "options": {
              "academicStaff": "Pessoal Académico",
              "administrativeStaff": "Pessoal Administrativo",
              "regulator": "Funcionário Governamental/Regulador",
              "researcher": "Investigador",
              "other": "Candidato a Emprego/Estudante/Outro"
            }
          },
          "All steps": "Todos os passos",
          "Password": "Palavra-passe",
          "draft-notion": "Todas as alterações são guardadas ao clicar em Seguinte",
          "draft-final-notion": "O benchmark será criado depois de clicar em Submeter",
          "existing-user-error": "Já existe um utilizador com este email. Por favor, introduza a palavra-passe para continuar",
          "invalid-email-error": "O e-mail é inválido",
          "password-error": "Palavra-passe incorreta",
          "credentials-panel": "Credenciais de Acesso",
          "result-chart":{
            "owner-label": "Responsável",
            "score-label": "Pontuação",
            "user-score-label": "Os seus resultados",
            "vitae-score-label": "Benchmark Vitae 360°",
            labels: {
              0: "(0) Inexistente",
              1: "(1) Inicial",
              2: "(2) Emergente",
              3: "(3) Avançado",
              4: "(4) Referência"
            },
            "updated-at-label": "Última atualização em"
          },
        }
      }
    },
    lng: "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
